<script>
import {mapState, mapMutations} from 'vuex';
import {ElMessage} from "element-plus";

export default {
  name: "SlideMenuComponent",
  computed: {
    ...mapState(['sidebarOpen']) // 引入sidebarOpen状态
  },
  methods: {
    ...mapMutations(['toggleSidebar']), // 引入toggleSidebar方法
    unOpened() {
      ElMessage.info({
        duration: "5000",
        message: this.$t("unOpened")
      })
      this.toggleSidebar()
    }
  }
}
</script>

<template>
  <div class="slideMenu" v-if="sidebarOpen">
    <div class="shadow"></div>
    <div class="content">
      <div class="close" @click="toggleSidebar"></div>
      <ul>
        <li>
          <h2 class="h2tit">
            <router-link :to="{ name: 'home' }" @click="toggleSidebar">
              <img src="images/icon1.png" alt="">
              <span>{{ $t("home") }}</span>
            </router-link>
          </h2>
        </li>
        <li>
          <h2 class="h2tit">
            <router-link :to="{ name: 'hashRate' }" @click="toggleSidebar">
              <img src="images/icon2.png" alt="">
              <span>{{ $t("myHashrate") }}</span>
            </router-link>
          </h2>
        </li>
        <li>
          <h2 class="h2tit">
            <router-link :to="{ name: 'team' }" @click="toggleSidebar">
              <img src="images/icon3.png" alt="">
              <span>{{ $t("myTeam") }}</span>
            </router-link>
          </h2>
        </li>
        <li>
          <h2 class="h2tit">
            <router-link :to="{ name: 'mining' }" @click="toggleSidebar">
              <img src="images/icon4.png" alt="">
              <span>{{ $t("hashrateMining") }}</span>
            </router-link>
          </h2>
        </li>
        <li>
          <h2 class="h2tit">
            <a href="javascript:" @click="unOpened">
              <img src="images/icon5.png" alt="">
              <span>{{ $t("stakingMining") }}</span>
            </a>
          </h2>
        </li>
        <li>
          <h2 class="h2tit">
            <a href="javascript:" @click="unOpened">
              <img src="images/icon6.png" alt="">
              <span>{{ $t("hashrateService") }}</span>
            </a>
          </h2>
        </li>
        <li>
          <h2 class="h2tit">
            <a href="https://pancakeswap.finance/swap?inputCurrency=0x55d398326f99059fF775485246999027B3197955&outputCurrency=0x0592c81e7aF7c7b7F4Bf8F43C43A5b5A9914EC5a"
               target="_blank">
              <img src="images/icon7.png" alt="">
              <span>{{ $t("trade") }}</span>
            </a>
          </h2>
        </li>
        <li>
          <h2 class="h2tit">
            <a href="https://pancakeswap.finance/add/0x55d398326f99059fF775485246999027B3197955/0x0592c81e7aF7c7b7F4Bf8F43C43A5b5A9914EC5a"
               target="_blank">
              <img src="images/icon8.png" alt="">
              <span>{{ $t("addLiquidity") }}</span>
            </a>
          </h2>
        </li>
        <li>
          <h2 class="h2tit">
            <a href="javascript:" @click="unOpened">
              <img src="images/icon9.png" alt="">
              <span>{{ $t("announcement") }}</span>
            </a>
          </h2>
        </li>
        <li>
          <h2 class="h2tit">
            <a href="javascript:" @click="unOpened">
              <img src="images/icon10.png" alt="">
              <span>{{ $t("helpCenter") }}</span>
            </a>
          </h2>
        </li>
        <li>
          <h2 class="h2tit">
            <a href="javascript:" @click="unOpened">
              <img src="images/icon11.png" alt="">
              <span>{{ $t("aboutAIR1") }}</span>
            </a>
          </h2>
        </li>
      </ul>
    </div>
  </div>
</template>

<style scoped>

</style>